import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Rainference | All Rights Reserved</p>
      <div>
        <a href="https://x.com/rainference" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faXTwitter} className="icon-style" />
        </a>
      </div>


    </footer>
  );
};

export default Footer;

